import { useNavigate } from 'react-router-dom';
import { PlayCircle, LogIn } from 'lucide-react';

const TheShowEntryPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#060d1b] flex items-center justify-center px-4" data-testid="the-show-entry">
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#0077FF]/10 border border-[#0077FF]/20 mb-5">
            <PlayCircle className="w-8 h-8 text-[#0077FF]" />
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-white tracking-tight">The Show</h1>
          <p className="text-white/40 text-sm mt-2">Choose how you'd like to proceed</p>
        </div>

        {/* Choices */}
        <div className="space-y-3">
          {/* Enter the Showroom */}
          <button
            onClick={() => navigate('/the-show/experiences')}
            className="w-full group flex items-center gap-4 px-6 py-5 rounded-xl border border-[#0077FF]/20 bg-[#0077FF]/[0.06] hover:bg-[#0077FF]/15 hover:border-[#0077FF]/40 transition-all duration-200"
            data-testid="the-show-enter-showroom"
          >
            <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[#0077FF]/15 flex items-center justify-center group-hover:bg-[#0077FF]/25 transition-colors">
              <PlayCircle className="w-5 h-5 text-[#0077FF]" />
            </div>
            <div className="text-left flex-1 min-w-0">
              <p className="text-sm font-semibold text-white group-hover:text-white/95 transition-colors">
                Enter the Showroom
              </p>
              <p className="text-xs text-white/35 mt-0.5">
                Launch interactive experiences
              </p>
            </div>
            <svg className="w-4 h-4 text-white/20 group-hover:text-[#0077FF]/60 transition-colors flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
            </svg>
          </button>

          {/* Portal Login */}
          <button
            onClick={() => navigate('/admin/login')}
            className="w-full group flex items-center gap-4 px-6 py-5 rounded-xl border border-white/[0.08] bg-white/[0.03] hover:bg-white/[0.06] hover:border-white/[0.15] transition-all duration-200"
            data-testid="the-show-portal-login"
          >
            <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-white/[0.06] flex items-center justify-center group-hover:bg-white/[0.1] transition-colors">
              <LogIn className="w-5 h-5 text-white/50 group-hover:text-white/70 transition-colors" />
            </div>
            <div className="text-left flex-1 min-w-0">
              <p className="text-sm font-semibold text-white/80 group-hover:text-white/90 transition-colors">
                Portal Login
              </p>
              <p className="text-xs text-white/30 mt-0.5">
                Access the admin portal
              </p>
            </div>
            <svg className="w-4 h-4 text-white/15 group-hover:text-white/30 transition-colors flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TheShowEntryPage;
